import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import Splide from '@splidejs/splide';
import {TranslateLoader, TranslateModule, TranslateService} from "@ngx-translate/core";
@Component({
  selector: 'content-sliders',
  templateUrl: './content-sliders.component.html',
  styleUrls: ['./content-sliders.component.scss']
})
export class ContentSlidersComponent implements OnInit {
@Input() datoSlider?: any;
@Input() datoSlider2?: any;
idiomaActual:any;
  constructor(private translateSrv: TranslateService,) {
    this.idiomaActual = this.translateSrv.currentLang;
    this.translateSrv.onLangChange.subscribe(() => {
      this.idiomaActual = this.translateSrv.currentLang;
    });
  }

  ngOnInit(): void {
    console.log("entro entro entro");

    console.log('content3',this.datoSlider);
    setTimeout(() => {
      new Splide( '.splide_galeria', {
        type: 'loop',
        gap: 10,
        autoplay: true,
        interval: 3000,
        pauseOnHover: true
      } ).mount();
    });


  }

}
